import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'

const DownloadsListStyled = styled.ul`
  @media ${media.phone} {
    column-count: 2;
    column-gap: 7.5rem;
    -webkit-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
    column-gap: 7.5rem;
  }
`

const DownloadsListItemStyled = styled.li`
  padding-bottom: 0.375rem;

  @media ${media.maxPhone} {
    width: 100%;
  }
  @media ${media.phone} {
    padding-bottom: 1.25rem;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }
`

export { DownloadsListStyled, DownloadsListItemStyled }
